export const state = {
  fPlusIntegrationToken: '',
}

export const actions = {
  setToken({ commit }, param) {
    commit('setFraudPlusToken', param)
  },
}

export const mutations = {
  setFraudPlusToken(state, param){
    state.fPlusIntegrationToken = param
  },
}
